module.exports = __webpack_public_path__ + "media/images/icons/loader-4db3717fc8ab300e6c7ac0cb6bfc5124.svg";